class JSEventObj {
    constructor(name) {
        this.name = name;
        this.handlers = [];
    }

    registerHandler(handler) {
        if (handler == null) return;
        if (this.handlers[handler] == null) {
            this.handlers.push(handler);
            console.log(`register handler event [${this.name}]`)
        }
    }

    unregisterHandler(handler) {
        const idx = this.handlers.indexOf(handler);
        if (idx >= 0) {
            this.handlers.splice(idx, 1);
            console.log(`unregister handler event [${this.name}]`)
        }
    }

    emit(arg) {
        this.handlers.forEach(h => {
            h(arg)
        });
    }
}

let events = [];

const on = (name, handler) => {
    let event = events[name];
    if (event == null) {
        event = events[name] = new JSEventObj(name);
    }
    event.registerHandler(handler);
}

const remove = (name, handler) => {
    let event = events[name];
    if (event != null) {
        event.unregisterHandler(handler);
        return true;
    }
    return false;
}

const emit = (name, args) => {
    let event = events[name];
    console.log(`emit event [${name}]`)
    if (event != null) {
        event.emit(args);
        return true;
    }
    return false;
}

const Events = {
    System: {
        /**
         * Ready事件发送条件
         * 
         * 1、native调用setClientInfo后
         * 
         * 2、系统加载完毕1秒后
         * 
         * 主要为了保证让natevi能够有时间调用setClientInfo来设置客户端的moduleId
         */
        Ready: "SYSTEM_READY"
    },
    Wallet: {
        Ready: "WALLET_READY",
        Created: "WALLET_CREATED",
        Reset: "WALLET_RESET",
        /**
         * walletService.data中的数据有更新时，发送，{name:string, value:string}
         */
        DataUpdate: "WALLET_DATA_UPDATE",
        /**
         * transcation提交到链上后发送，供检查状态
         */
        PenddingTransaction: "WALLET_PENDING_TRANSACTION",
        /**
         * transaction状态变化
         */
        TransactionUpdate: "WALLET_TRANSACTION_UPDATE",
        /**
         * transaction成功后发送，用户更新token数量
         */
        Transaction: "WALLET_TRANSACTION",
        /**
         * walletInfo中的token余额变化时发送，数据为{token:Token, balance:String}
         */
        BalanceUpdate: "WALLET_BALANCE_UPDATE",

        /**
         * DeFi钱包下的某个token账户发生变化时发送，从链上来的事件
         */
        WalletAccountChanged: "WALLET_ACCOUNT_CHANGED"
    },
    Login: {
        LoginSuccessful: "LOGIN_SUCCESSFUL"
    },
    MainMenu: {
        /**
         * 发送此事件可主动切换主菜单 {menu:menuName(见Config.MenuConfig), args:{}}
         */
        SwitchMenu: "MAINMENU_SWITCH_MENU"
    },
    Connection: {
        Connected: "CONNECTION_CONNECTED",
        Disconnected: "CONNECTION_DISCONNECTED",
    },

    DataCenter: {
        /**
         * datacenter已载入完毕，可以读取数据了
         */
        DATA_READY: "DATACENTER_DATA_READY",
        /**
             * 数据更新事件，参数为数据名称, wallet, symbol 等
             */
        DATA_UPDATED: "DATACENTER_DATA_UPDATED"
    },

    /**
     * 交易相关事件
     */
    Trade: {
        ORDER_PLACED: "TRADE_ORDER_PLACED",
        ORDER_CANCELED: "TRADE_ORDER_CANCELED",
        ORDER_UPDATED: "TRADE_ORDER_UPDATED",
    }

}

const JSEvent = {
    on: on,
    remove: remove,
    emit: emit,
}

export { Events, JSEvent }

